// ChatWebsocketService.js
import { useEffect, useRef } from 'react';
import * as signalR from '@microsoft/signalr';
import { connect } from '../../../node_modules/react-redux/dist/react-redux';
import useAuth from '../context/useAuth';

const ChatWebsocketService = ({ onConnectionEstablished }) => {
    const connectionRef = useRef(null);
    const { auth } = useAuth();
    const authRef = useRef(auth);

    useEffect(() => {
       const url = `https://${document.location.host}/auctionHub`;
      //const url = `http://${document.location.host}/auctionHub`;
       //const url = `https://${document.location.host}/auctionHub`;

        console.log("connecting....")
        connectionRef.current = new signalR.HubConnectionBuilder()
            .withUrl(url, { accessTokenFactory: () => `${authRef.current.accessToken}`  })
            .configureLogging(signalR.LogLevel.Information)
            //.withKeepAliveIntervalInMilliseconds(300000)
            .withAutomaticReconnect() 
            .build();

        connectionRef.current.start().then(() => {
            console.log("Connection established successfully!");
            onConnectionEstablished();
            
        }).catch((err) => console.error(err, 'red'));

        connectionRef.current.onclose((error) => {
            console.log("Connection closed:", error);
        });

        return () => {
            console.log("stopping connection!");
            connectionRef.current.stop().then(() => {
               console.log("CONNECTION STOPPED")
            }).catch((err) => console.error(err, 'red'));;
        }; 
    }, []);

    const registerConnectionEstablished = (connectionEstablished) => {
        connectionEstablished();
    };

    const registerUserLoggedOn = (userLoggedOn) => {
        connectionRef.current.on('UserJoined', (user) => {
            userLoggedOn(user);
        });
    };

    const registerUserLoggedOut = (userLoggedOut) => {
        connectionRef.current.on('UserLeft', (user) => {
            console.log("logging out")
            userLoggedOut(user);
        });
    };

    const registerTimerTick = (timerTick) => {
        connectionRef.current.on('TimerTick', (seconds) => {
            console.log("on('TimerTick called [seconds : " + seconds.toString() + "]" + new Date())
            timerTick(seconds);
        });
    };

    const registerTimerTimeout = (timerTimeout) => {
        connectionRef.current.on('TimeTimeout', (lotId) => {
            console.log("on TimeTimeout called [seconds : " + lotId.toString() + "]" + new Date())
            timerTimeout(lotId);
        });
    };

    const registerMessageReceived = (messageReceived) => {

        connectionRef.current.on('MessageReceived', (message) => {
            messageReceived(message);
        });
    };

    const sendMessage = (message) => {
        connectionRef.current.invoke('SendMessage', message)
            .catch((error) => {
                console.error("Error sending message:", error);
            });;
        
    };

    return {
        registerUserLoggedOn,
        registerUserLoggedOut,
        registerTimerTick,
        registerTimerTimeout,
        registerMessageReceived,
        sendMessage
    };
};

export default ChatWebsocketService;


